import { useState } from 'react';
import { copyText } from '../lib/format';
import type { ProjectKit } from '../lib/types';
import { Button } from './ui';

/** One ready-to-send message at a time. The green gate is the only path to sharing. */
export function ProjectMessages({ messages, footer, lane }: {
  messages: NonNullable<ProjectKit['messages']>; footer: string; lane: ProjectKit['lane'];
}) {
  const [tab, setTab] = useState(0);
  const [copied, setCopied] = useState(false);
  const msg = messages[Math.min(tab, messages.length - 1)];
  const full = msg ? `${msg.text}${footer ? `\n\n${footer}` : ''}` : '';
  const canShare = lane === 'green';
  async function copy() {
    await copyText(full);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }
  if (!messages.length) return null;

  return <div>
    <div className="mb-3 flex items-center justify-between gap-2"><h3 className="text-sm font-extrabold text-ink">Buyer-ready messages</h3><span className="text-xs font-medium text-muted">3 conversation starters</span></div>
    <div className="mb-3 flex gap-1 rounded-xl bg-surface2 p-1 text-xs font-semibold" role="tablist" aria-label="Choose a buyer message">
      {messages.map((m, i) => <button key={m.label} role="tab" aria-selected={tab === i} onClick={() => setTab(i)}
        className={`min-h-[38px] min-w-0 flex-1 rounded-lg px-1 py-2 sm:px-2 ${tab === i ? 'bg-white text-accent shadow-sm' : 'text-muted hover:text-ink'}`}>{m.label}</button>)}
    </div>
    <div role="tabpanel" className="mb-3 rounded-2xl border border-line bg-[#eef5f9] p-4 text-sm">
      <p className="mb-3 text-[10px] font-extrabold uppercase tracking-[.12em] text-muted">WhatsApp preview · {msg?.label}</p>
      <div className="max-w-[95%] rounded-2xl rounded-tl-sm bg-white px-4 py-3 shadow-[0_3px_10px_rgba(23,40,61,.05)]">
        <p className="whitespace-pre-wrap leading-relaxed">{(msg?.text ?? '').split(/(\*[^*\n]+\*)/).map((part, i) => part.startsWith('*') && part.endsWith('*') && part.length > 2 ? <strong key={i}>{part.slice(1, -1)}</strong> : part)}</p>
        {footer && <p className="mt-3 whitespace-pre-wrap border-t border-line pt-2 text-[11px] leading-relaxed text-muted">{footer}</p>}
      </div>
    </div>
    {canShare ? <div className="grid grid-cols-2 gap-2 sm:flex">
      <Button variant="primary" onClick={copy}>{copied ? 'Copied ✓' : 'Copy message'}</Button>
      <a href={`https://wa.me/?text=${encodeURIComponent(full)}`} target="_blank" rel="noreferrer"
        className="inline-flex min-h-[40px] items-center justify-center rounded-xl border border-line bg-white px-3.5 py-2 text-sm font-bold text-accent hover:bg-surface2">Open WhatsApp ↗</a>
    </div> : <p className="rounded-xl bg-warnSoft px-3 py-2.5 text-sm font-medium text-warn">This brief is not cleared for buyers. Sharing unlocks after the fact check passes.</p>}
  </div>;
}
